'use client';

import { useCookieConsent } from '@mihilista/cookie-consent';
import { useTranslations } from 'next-intl';

export default function CookieSettingsButton() {
    const { CookiePreferencesButton } = useCookieConsent();
    const t = useTranslations('cookies');

    return (
        <CookiePreferencesButton className="uppercase underline mouse-hover:no-underline inline-flex cursor-pointer text-left">
            {t('settingsButton')}
        </CookiePreferencesButton>
    );
}
